module.exports = __webpack_public_path__ + "images/_/programs/epsIntermediates/images/characters/sara_smile-235bfd423fca04d38d1338973d9baaa5.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsIntermediates/images/characters/sara_smile.png
// module id = 418
// module chunks = 2